import React, { useState } from "react";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { base_url } from "../env";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { OrbitProgress } from "react-loading-indicators";
import { useDispatch } from "react-redux";
import EasyPosLogo from "../Images/EasyPOSLogo.png";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [user, setUser] = useState({ username: "", pwd: "" });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const token =
    "OWdBQUFCK0xDQUFBQUFBQUFBbzlqczBPZ2pBUWhGK2w2ZGtRa0FRU2JpcGUvUW5xdmNKcURLV3R1MFZDakQ2N0xjRm1UN1B6VFdiZWZLTTdJOVM0RXgzd3dpbFZnN0hzQkMycnRPenRReXUrNEpXKzJVRWcvQ25aWDlrZUcwQzJNc2I1RjBEeVpNR1RLUGJuTTRBdndEbEI5NldTM1VoUG1SdEpiVVJROXdnMElaRUNHL2lEUnV2NE5JMno4RHM3Ym03MWF5Y1plRUUwYUd5Y2YweUhyUDJxUEFsbXVaN3J0LzlzS2F6Z254OHFwQWVYOWdBQUFBPT0=";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({ ...prev, [name]: value }));
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  const checkUpdates = () => {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      tokenData:
        "RGdFQUFCK0xDQUFBQUFBQUJBQTlqODBPZ2pBUWhGK0Y3SmtRRUFNSk54VVBYdndKNnIzQ2FneWxyZHNpSVFTZjNVS0E3R2wydnNuc2RtQmtpUUtTRG5heVVreTBSMVloSkZhSkhKVnhybGc2bWVTMWVVc0JMbVR5YVJwR09GTzhmamduS3BDY2pWTFd2eVBwZ1V3ZzhQeGhoZ3pTRjJsSzZOZEs4S3JWSHg0cnJrdFBZMTRUNmhIeEJKcUZQMHN5bGc5RFAxcDJOOHROcmNPMW8xeDRwblVqcWJEK0pXeWk4aWZpWURIVDdWUy9uN01wTXd4NmQvNzZrRUt5N3YvRVNxRTlEZ0VBQUE9PQ==",
    });

    fetch(`${base_url}/CheckUpdates`, {
      method: "POST",
      headers,
      body: raw,
    })
      .then((res) => res.json())
      .then((result) => console.log("Update Status:", result.status))
      .catch((error) => console.error("Update Check Failed", error));
  };

  const handleLogin = (e) => {
    e.preventDefault();

    if (!user.username || !user.pwd) {
      toast.error("Username and Password are required", { autoClose: 1500 });
      return;
    }

    setLoading(true);
    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      tokenData: token,
      user: user.username,
      pwd: user.pwd,
    });

    fetch(`${base_url}/Admin_VerifyLogin`, {
      method: "POST",
      headers,
      body: raw,
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status) {
          localStorage.setItem("userToken", token);
          localStorage.setItem("username", user.username);
          navigate("/companies");
          checkUpdates();
        } else {
          toast.error(result.error || "Login Failed", { autoClose: 1500 });
        }
        setLoading(false);
      })
      .catch(() => {
        toast.error("API Failed", { autoClose: 1500 });
        setLoading(false);
      });
  };

  return loading ? (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <OrbitProgress color="#0d6efd" size="medium" text="E Club" />
    </div>
  ) : (
    <>
      <ToastContainer />
      <div className="container mt-5 mb-5 d-flex justify-content-center align-items-center col-lg-5">
        <div className="card px-4 py-4 text-center w-100 shadow-sm">
          <div className="mb-3">
            <img src={EasyPosLogo} alt="EasyPOS" width="70%" />
          </div>
          <h3 className="mb-4">Administrator Login</h3>
          <form onSubmit={handleLogin}>
            <div className="form-group mb-3 text-start">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                className="form-control border border-dark"
                name="username"
                placeholder="Enter Username"
                value={user.username}
                onChange={handleChange}
              />
            </div>
            <div className="form-group mb-4 text-start">
              <label htmlFor="pwd">Password</label>
              <div className="input-group">
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  className="form-control border border-dark"
                  name="pwd"
                  placeholder="Enter Password"
                  value={user.pwd}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={togglePasswordVisibility}
                >
                  {isPasswordVisible ? <BsEye /> : <BsEyeSlash />}
                </button>
              </div>
            </div>
            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
            >
              Login
            </button>
            <div className="mt-3 text-muted">
              <small>Go to the EPOS Admin Dashboard</small>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
